import Album from "../components/Album";

function Acomodacao() {
  return <div>
      <Album/>
  </div>;
}
export default Acomodacao;
